import { render, staticRenderFns } from "./print-button.vue?vue&type=template&id=3085d87e&scoped=true&"
import script from "./print-button.vue?vue&type=script&lang=js&"
export * from "./print-button.vue?vue&type=script&lang=js&"
import style0 from "./print-button.vue?vue&type=style&index=0&id=3085d87e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3085d87e",
  null
  
)

export default component.exports